module.exports = __webpack_public_path__ + "static/img/qimen.eed1cd41.png";